
document.addEventListener('ShoptetDOMPageContentLoaded', function () {
    customProduct()
});
document.addEventListener('ShoptetPageSortingChanged', function () {
    customProduct();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function () {
    customProduct();
});
$(document).ready(function () {
    customProduct();
})

function customProduct() {
    $('.product').each(function () {
        const $product = $(this);
        const $priceStandard = $product.find('.price-standard');
        if ($priceStandard.length) {
            $product.find('.prices').prepend($priceStandard);
        }
        const $desc = $product.find('.p-desc');
        const $code = $product.find('.p-code');
        if ($desc.length) {
            $product.find('.p-in-in').append($desc);
        }
        if ($code.length) {
            $product.find('.p-in-in').append($code);
        }
        const $flagsDefault = $product.find('.flags-default');

        const $flagWrapper = $('<div class="flagWrapper"></div>');
        Object.values(operacniSystemy).forEach(function (className) {
            const $flag = $flagsDefault.find('.' + className);

            if ($flag.length) {
                $flagWrapper.append($flag.clone());
            }
        });

        if ($flagWrapper.children().length) {
            $product.find('.ratings-wrapper').prepend($flagWrapper);
        }

    });
}
